import { reportException } from "./logs";

const isPendoEnabled = process.env.REACT_APP_PENDO_ENABLED === 'true';

const initializePendoAnonymous = () => {
    if (isPendoEnabled) {
        const pendoScript = (window as any).pendo;
        if (typeof pendoScript !== 'undefined') {
            pendoScript.clearSession();
            if (!pendoScript.isReady()) {
                pendoScript.initialize({
                    visitor: null,
                    account: null,
                })
            }
        } else {
            console.error('Could not load Pendo');
            reportException('Could not load Pendo');
        }
    }
}

const createPendoOnboardingData = (data: any) => {
    if (isPendoEnabled) {
        if (data != null) {
            const initialData = {
                visitor: {
                    id: data?.contactInfo?.email,
                    email: data?.contactInfo?.email,
                    visitorType: 'onboarding',
                    firstName: data?.contactInfo?.firstName,
                    lastName: data?.contactInfo?.lastName,
                    city: data?.contactInfo?.city,
                    state: data?.contactInfo?.state,
                    zipCode: data?.contactInfo?.zipCode,
                    address1: data?.contactInfo?.address1,
                    carrierId: data?.carrierInfo?.carrierId,
                    carrierName: data?.carrierInfo?.carrierName,
                    numberOfTrucks: data?.carrierInfo?.numberOfTrucks,
                    numberOfDrivers: data?.carrierInfo?.numberOfDrivers,
                    invitedDate: data?.statusInfo.invited,
                    invitationStatus: data?.statusInfo.status,
                },
                account: {
                    id: data?.invitationInfo.invitingUserEmail,
                    email: data?.invitationInfo.invitingUserEmail,
                    companyName: data?.invitationInfo.invitingCompanyName,
                    companyShortCode: data?.invitationInfo.companyShortCode,
                    companyId: data?.invitationInfo.invitingCompanyId,
                    firstName: data?.invitationInfo.invitingUserFirstName,
                    lastName: data?.invitationInfo.invitingUserLastName,
                    isInsurance: data?.invitationInfo.isInsurance,
                    canUseOAuth: data?.invitationInfo.canUseOAuth,
                }
            }
            initializePendo(initialData.visitor, initialData.account);
        }
    }
}

const initializePendo = (visitor: any, account: any) => {
    if (isPendoEnabled) {
        const pendoScript = (window as any).pendo;
        if (typeof pendoScript !== 'undefined') {
            if (!pendoScript.isReady()) {
                pendoScript.initialize({
                    visitor,
                    account,
                });
            }
            else {
                pendoScript.identify({
                    visitor,
                    account,
                })
            }
        } else {
            console.error('Could not load Pendo');
            reportException('Could not load Pendo');
        }
    }
};

export { createPendoOnboardingData, initializePendo, initializePendoAnonymous }